import React from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { format, isToday } from 'date-fns'
import { Header } from '@crossfit/ui'

import {
  ProgrammingClassType,
  ProgrammingTrack,
  DailyClassPlan,
} from 'pages/Programming/types'
import Tag from 'pages/Programming/components/Tag'
import style from './style.module.css'
import WorkoutText from 'pages/Programming/components/WorkoutText'

function formatDateToDay(date: Date) {
  return format(date, 'EEE')
}

function formatDateNumeric(date: Date) {
  return format(date, 'yy.MM.dd')
}

type Props = {
  dailyClassPlan: DailyClassPlan
}

function Description({ dailyClassPlan }: Props) {
  const { workouts, track } = dailyClassPlan

  if (track === ProgrammingTrack.CompeteTrack) {
    const { workoutOrder } = dailyClassPlan

    return workoutOrder ? (
      <>
        {workoutOrder.map((item) => (
          <div className={style.workoutOrderRow} key={item.element}>
            <div className={style.element}>{item.element}</div>
            <div className={style.time}>{item.timeEstimate} min</div>
          </div>
        ))}
      </>
    ) : null
  }

  return workouts ? <WorkoutText>{workouts[0].description}</WorkoutText> : null
}

function DailyClassPlanCard({ dailyClassPlan }: Props) {
  const { slug, date, name, type } = dailyClassPlan
  const isRestDay = type === ProgrammingClassType.RestDay
  const showTodayBanner = isToday(date)

  return (
    <Link
      className={classNames(style.wrapper, {
        [style.restDay]: isRestDay,
      })}
      to={slug}
    >
      {showTodayBanner && <div className={style.topBanner}>Today</div>}
      <div className={style.content}>
        <header className={style.header}>
          <div className={style.day}>{formatDateToDay(date)}</div>
          {!isRestDay && type && <Tag className={style.tag}>{type}</Tag>}
        </header>

        <Header size='medium' mb={3} as='h3' className={style.blackHeader}>
          {isRestDay ? formatDateNumeric(date) : name}
        </Header>

        {isRestDay && <div className={style.restDaySubTitle}>Rest Day</div>}

        <Description dailyClassPlan={dailyClassPlan} />
      </div>
    </Link>
  )
}

export default DailyClassPlanCard
